/**
 * Generate a consistent background color for avatar initials based on a name
 * @param name - The user's name to generate a color for
 * @returns A Tailwind CSS background color class
 */
export function getAvatarColor(name: string): string {
  // Predefined set of attractive colors for avatars
  const colors = [
    'bg-red-500',
    'bg-orange-500', 
    'bg-amber-500',
    'bg-yellow-500',
    'bg-lime-500',
    'bg-green-500',
    'bg-emerald-500',
    'bg-teal-500',
    'bg-cyan-500',
    'bg-sky-500',
    'bg-blue-500',
    'bg-indigo-500',
    'bg-violet-500',
    'bg-purple-500',
    'bg-fuchsia-500',
    'bg-pink-500',
    'bg-rose-500'
  ];

  // Generate a simple hash from the name to get a consistent index
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    const char = name.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }

  // Use absolute value and modulo to get a valid array index
  const index = Math.abs(hash) % colors.length;
  return colors[index];
}

/**
 * Generate initials from a full name
 * @param name - The full name to extract initials from
 * @returns The initials (typically 1-2 characters)
 */
export function getInitials(name: string): string {
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2); // Limit to 2 characters max
}
